import BlockTypes from 'composer-blocks/lib/constants/BlockTypes';
import * as BlockTemplates from './block_templates';
import { groupBy } from 'composer-blocks/lib/helpers/hasMany';

export const blocksByType = groupBy(BlockTypes, BlockTemplates, 'type');
export default BlockTemplates;
